import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function ShareIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="16" cy="5" r="2" fill={props.fill} stroke={props.fill} strokeWidth="2" />
			<circle cx="16" cy="18" r="2" fill={props.fill} stroke={props.fill} strokeWidth="2" />
			<path opacity="0.5" d="M6 11L16 5" stroke={props.fill} strokeWidth="2" />
			<path opacity="0.5" d="M6 11L16 18" stroke={props.fill} strokeWidth="2" />
			<circle cx="6" cy="11" r="2" fill={props.fill} stroke={props.fill} strokeWidth="2" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<ShareIcon fill={props.fill} />
		</div>
	);
}